import styles from './ErrorNotification.module.css'

const ErrorNotification = ({notificationText}: {notificationText: string}) => {
    return <p className={styles.errorNotification}>{notificationText}</p>
}

export default ErrorNotification
